import React, { useCallback, useRef, useState } from 'react';
import { Layout } from 'fronton-react';
import {
  ButtonWithGAClickButton,
  HeaderSection,
  OtherSection,
  ReviewsBenefits,
  ReviewsCatalog,
  ReviewsSection,
  RootLayout,
} from 'common/components';
import { useIsomorphicLayoutEffect } from 'common/hooks';
import { fullWidthMobileButton } from 'common/styles/common';
import { useRegionIdSelector } from 'modules/model-json';
import { PromoBlock } from 'remotes/promo-block';
import { SpecialOffer } from 'remotes/special-offer';
import {
  CabinetBenefits,
  CabinetDesignPanel,
  CabinetGallery,
  CabinetPeculiarities,
  CabinetQuestions,
  CabinetSignSection
} from './components';
import {
  CABINET_ELEMENT_BLOCK,
  CABINET_HEADER_IMAGE_LIST,
  CABINET_LANDING_NAME,
  CABINET_PATH,
  CABINET_REVIEWS_BENEFITS,
  CABINET_REVIEWS_DATA,
} from './cabinet-constants';

export const Cabinet = () => {
  const [isStickyPanelVisible, setIsStickyPanelVisible] = useState<boolean>(true);
  const signSectionPanelRef = useRef<HTMLDivElement | null>(null);
  const regionId = useRegionIdSelector();

  const designRegistrationHref = `/zapis-onlayn/?department_no=14&region_id=${regionId}`;

  const handleScroll = useCallback(() => {
    if (signSectionPanelRef) {
      const heightVh = signSectionPanelRef.current?.offsetTop || 0;
      const scrollHeightWithWindow = window.scrollY + window.innerHeight;

      setIsStickyPanelVisible(scrollHeightWithWindow < heightVh);
    }
  }, [signSectionPanelRef]);

  useIsomorphicLayoutEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);


  return (
    <RootLayout currentPage={CABINET_PATH}>
      <HeaderSection
        bgColor="#A0B9B1"
        description="Сделаем бесплатный дизайн-проект и&nbsp;замеры, подберём товары и&nbsp;доставим всё домой"
        imgList={CABINET_HEADER_IMAGE_LIST}
        mediaType="carousel"
        textColor="text-primary"
        title="Шкафы и&nbsp;двери-купе на&nbsp;заказ"
      />
      <CabinetDesignPanel isConsultationFormVisible={!isStickyPanelVisible} signUpHref={designRegistrationHref} />
      <Layout>
        <PromoBlock elementBlock={CABINET_ELEMENT_BLOCK} />
        <SpecialOffer elementBlock={CABINET_ELEMENT_BLOCK} />
        <CabinetBenefits signUpHref={designRegistrationHref} />
        <CabinetGallery signUpHref={designRegistrationHref} />
      </Layout>
      <ReviewsSection
        benefits={
          <ReviewsBenefits benefitsList={CABINET_REVIEWS_BENEFITS} newVariant />
        }
        review={
          <ReviewsCatalog
            elementBlock={CABINET_ELEMENT_BLOCK}
            modalButton={
              <ButtonWithGAClickButton
                className={fullWidthMobileButton}
                elementBlock={`${CABINET_ELEMENT_BLOCK} / Reviews`}
                elementName="Отзывы клиентов / modal"
                elementText="Записаться на проектирование"
                title="Запишитесь на проектирование"
                href={designRegistrationHref}
                target="_blank"
                variant="accent"
                wide
              >
                Записаться на проектирование
              </ButtonWithGAClickButton>
            }
            newVariant
            reviewsList={CABINET_REVIEWS_DATA}
          />
        }
        reviewTitle="Галерея работ для&nbsp;вдохновения"
        title="Запишитесь на&nbsp;бесплатное проектирование, а&nbsp;мы&nbsp;позаботимся о&nbsp;всех этапах"
      />
      <Layout>
        <CabinetPeculiarities />
      </Layout>
      <CabinetSignSection panelRef={signSectionPanelRef} signHref={designRegistrationHref} />
      <Layout>
        <CabinetQuestions />
      </Layout>
      <OtherSection
        elementBlock={`${CABINET_ELEMENT_BLOCK} / other`}
        landingName={CABINET_LANDING_NAME}
        promotionName={`${CABINET_ELEMENT_BLOCK}_bottom`}
        title="Другие системы хранения"
      />
    </RootLayout>
  );
}
